import { Component } from '@angular/core';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-import-database',
  templateUrl: './import-database.component.html',
  styleUrls: ['./import-database.component.scss'],
})
export class ImportDatabaseComponent {
  userName: any;
  constructor(private requestFormService: RequestFormService) {}
  ngOnInit(): void {
   this.userName = localStorage.getItem('username')
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
